import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable @typescript-eslint/member-ordering */
import * as React from 'react';
import * as PropTypes from 'prop-types';
import Trigger from '@mtfe/rc-trigger';
import dayjs from 'dayjs';
import { polyfill } from 'react-lifecycles-compat';
import createRef from '@roo/create-react-ref/createRef';
import locale from '../locale';
import { isFunction } from '@utiljs/is';
import IconClear from './IconClear';
import { PANEL_LIST } from './const';
import { getTimeValue, togglePanel, onOpenChange, mouseEnter, mouseLeave, dateFormatter } from './utils';
import { getPlacements } from './placements';
import Icon from '../Icon';
import Input from '../Input';
import DatePanel from './DatePanel';
import MonthPanel from './MonthPanel';
import YearPanel from './YearPanel';
import TimeSelect from './TimePicker';
import '@mtfe/rc-trigger/assets/index.css';

var DatePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  var _super = _createSuper(DatePicker);

  function DatePicker(props) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _super.call(this, props);
    _this.rootNode = createRef();
    _this.inputNode = createRef();

    _this.onOpenChange = function () {};

    _this.fold = false;
    /**
     * 通过 value 是否存在 props 决定受控状态。
     * defaultProps 不能设置 value 默认值！！！
     */

    _this.isControlled = function () {
      return 'value' in _this.props;
    }; // 受控判断
    // isControlled = () => {
    //     const {
    //         value,
    //     } = this.props;
    //     return value !== undefined && value !== null;
    // }


    _this.inputFocus = function () {
      if (_this.props.onFocus) {
        _this.props.onFocus();
      }
    };

    _this.inputBlur = function () {
      if (_this.props.onBlur) {
        _this.props.onBlur();
      }
    };
    /**
     * 根据时间获取每周的第一天和最后一天
     * @now dayjs
     * @return [dayjs, dayjs]
     */


    _this.getWeekData = function (now) {
      var weekStartDate = now;

      while (weekStartDate.day() !== 1) {
        weekStartDate = weekStartDate.subtract(1, 'day');
      }

      return [weekStartDate, weekStartDate.add(6, 'day').set('hour', 0).set('minute', 0).set('second', 0)];
    };
    /**
     * 天选择 day
     */


    _this.selectDate = function (timestamp) {
      var selectDate = _this.state.selectDate;
      var _this$props = _this.props,
          valueOfType = _this$props.valueOfType,
          onChange = _this$props.onChange,
          format = _this$props.format,
          showTime = _this$props.showTime,
          type = _this$props.type;
      var sd = dayjs(timestamp).set('hour', selectDate.hour()).set('minute', selectDate.minute()).set('second', selectDate.second());

      var handleChange = function handleChange() {
        if (type === 'week') {
          var _this$getWeekData = _this.getWeekData(sd),
              _this$getWeekData2 = _slicedToArray(_this$getWeekData, 2),
              weekStartDate = _this$getWeekData2[0],
              weekEndDate = _this$getWeekData2[1];

          if (isFunction(onChange)) {
            onChange(getTimeValue(valueOfType, sd, format), [getTimeValue(valueOfType, weekStartDate, format), getTimeValue(valueOfType, weekEndDate, format)]);
          }
        } else {
          if (isFunction(onChange)) {
            onChange(getTimeValue(valueOfType, sd, format));
          }
        }
      };

      if (_this.isControlled()) {
        _this.setState({
          open: showTime
        }, function () {
          handleChange();
        });
      } else {
        // TODO: code refactor (I dare not to change)
        if (type === 'week') {
          var _this$getWeekData3 = _this.getWeekData(sd),
              _this$getWeekData4 = _slicedToArray(_this$getWeekData3, 2),
              weekStartDate = _this$getWeekData4[0],
              weekEndDate = _this$getWeekData4[1];

          _this.setState({
            startDate: dayjs(timestamp),
            selectDate: weekStartDate,
            selectEndDate: weekEndDate,
            value: sd,
            open: false || showTime
          }, handleChange);
        } else {
          _this.setState({
            startDate: dayjs(timestamp),
            selectDate: sd,
            value: sd,
            open: false || showTime
          }, handleChange);
        }
      } // 关闭弹层？？


      if (!showTime) {
        _this.fold = true;
      }
    };

    _this.selectMonthOrYear = function (timestamp, panelType, e) {
      e.stopPropagation();
      var _this$props2 = _this.props,
          type = _this$props2.type,
          onChange = _this$props2.onChange,
          valueOfType = _this$props2.valueOfType,
          format = _this$props2.format;

      if (type === 'month' || type === 'year') {
        if ('value' in _this.props) {
          _this.fold = true;

          _this.setState({
            open: false
          }, function () {
            onChange(getTimeValue(valueOfType, dayjs(timestamp), format));
          });

          return;
        } else {
          var _tl = togglePanel(PANEL_LIST, "".concat(panelType, "Show"));

          _this.setState(_Object$assign({
            startDate: dayjs(timestamp),
            selectDate: dayjs(timestamp),
            value: dayjs(timestamp),
            open: false
          }, _tl));

          _this.fold = true;
          onChange(getTimeValue(valueOfType, dayjs(timestamp), format));
          return;
        }
      }

      var tl = togglePanel(PANEL_LIST, "".concat(panelType, "Show"));

      _this.setState(_Object$assign({
        startDate: dayjs(timestamp)
      }, tl));
    };

    _this.getThWeek = function (time) {
      if (!time) return '';
      var curDate = time;
      var firstDay = time.set('month', 0).set('date', 1);
      var diffDay = Math.round((curDate.valueOf() - firstDay.valueOf()) / (24 * 3600 * 1000));
      return Math.ceil((diffDay + firstDay.day()) / 7);
    };

    _this.getSelectedData = function (time, type) {
      var selectDate = _this.state.selectDate;
      var tempData = null; // 判断是否选择过日期, 没有选择过则使用当前时间

      if (selectDate.unix() === dayjs('0').unix()) {
        tempData = dayjs().set('second', 0).set('hour', 0).set('minute', 0).set(type, time);
      } else {
        tempData = selectDate.set(type, time);
      }

      return tempData;
    };
    /**
     * 时分秒选择
     */


    _this.selectTime = function (time, type) {
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          valueOfType = _this$props3.valueOfType,
          format = _this$props3.format;

      var handleChange = function handleChange() {
        var tempData = _this.getSelectedData(time, type);

        var curSelectDate = tempData.set(type, time);
        var sd = getTimeValue(valueOfType, curSelectDate, format);
        onChange(sd);
      };

      if (_this.isControlled()) {
        handleChange();
      } else {
        var tempData = _this.getSelectedData(time, type);

        _this.setState({
          selectDate: tempData,
          startDate: tempData,
          value: tempData
        }, handleChange);
      }
    };
    /**
     * 箭头图标切换年月
     */


    _this.handleChangeDate = function (type, unitType, count) {
      var startDate = _this.state.startDate;
      count = count || 1;
      var calcuDate = dayjs();
      calcuDate = type === 'add' ? startDate.add(count, unitType) : startDate.subtract(count, unitType);

      _this.setState({
        startDate: calcuDate
      });
    };
    /**
     * TODO: 清除时间，返回 '' 是否合理？
     **/


    _this.clearTime = function () {
      var _this$props4 = _this.props,
          onChange = _this$props4.onChange,
          value = _this$props4.value;

      if (value) {
        if (isFunction(onChange)) {
          onChange('');
        }
      } else {
        _this.setState({
          value: '',
          startDate: dayjs(),
          selectDate: dayjs('0'),
          selectEndDate: ''
        }, function () {
          if (isFunction(onChange)) {
            onChange('');
          }
        });
      }
    };

    _this.mouseEnter = mouseEnter.bind(_assertThisInitialized(_this));
    _this.mouseLeave = mouseLeave.bind(_assertThisInitialized(_this));

    _this.popupVisibleChange = function (isShow) {
      _this.fold = !isShow;
    };

    _this.showPanel = function (type) {
      var tl = togglePanel(PANEL_LIST, "".concat(type, "Show"));

      _this.setState(_Object$assign({}, tl));
    };

    var _this$props5 = _this.props,
        value = _this$props5.value,
        defaultValue = _this$props5.defaultValue,
        valueOfType = _this$props5.valueOfType,
        open = _this$props5.open,
        type = _this$props5.type;
    var oneValue = _this.isControlled() ? dateFormatter(value, valueOfType) : dateFormatter(defaultValue, valueOfType);
    var startDate = oneValue || dayjs();
    var selectDate = oneValue || dayjs('0');
    var selectEndDate = '';

    if (type === 'week' && oneValue) {
      var _this$getWeekData5 = _this.getWeekData(oneValue),
          _this$getWeekData6 = _slicedToArray(_this$getWeekData5, 2),
          d1 = _this$getWeekData6[0],
          d2 = _this$getWeekData6[1];

      selectDate = d1;
      selectEndDate = d2;
    }

    _this.state = {
      startDate: startDate,
      // NOTE: 默认选中时间是 2000-1-1: 00:00:00, 保证渲染时间内无选中的即可。
      selectDate: selectDate,
      selectEndDate: selectEndDate,
      value: oneValue,
      // eslint-disable-next-line
      initialValue: _this.props.value,
      dateShow: true,
      monthShow: false,
      yearShow: false,
      closeShow: false,
      open: open
    };
    return _this;
  }

  _createClass(DatePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onOpenChange = onOpenChange.bind(this);
      window.addEventListener('click', this.onOpenChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.onOpenChange);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          value = _this$state.value,
          startDate = _this$state.startDate,
          selectDate = _this$state.selectDate,
          selectEndDate = _this$state.selectEndDate,
          dateShow = _this$state.dateShow,
          monthShow = _this$state.monthShow,
          yearShow = _this$state.yearShow,
          open = _this$state.open,
          closeShow = _this$state.closeShow;
      var _this$props6 = this.props,
          showTime = _this$props6.showTime,
          placeholder = _this$props6.placeholder,
          format = _this$props6.format,
          disabledDate = _this$props6.disabledDate,
          type = _this$props6.type,
          popupContainer = _this$props6.popupContainer,
          className = _this$props6.className,
          clearable = _this$props6.clearable,
          disabled = _this$props6.disabled,
          dateCellRender = _this$props6.dateCellRender,
          inputClassName = _this$props6.inputClassName,
          size = _this$props6.size,
          disabledTime = _this$props6.disabledTime,
          placement = _this$props6.placement,
          flip = _this$props6.flip,
          timeClassName = _this$props6.timeClassName;
      var bodyPanel = null;
      var dateFormat = format && format.split(' ')[0];
      var datePicker = /*#__PURE__*/React.createElement("div", null, showTime ? /*#__PURE__*/React.createElement("div", {
        className: "roo-datepicker-inputs"
      }, /*#__PURE__*/React.createElement("input", {
        key: startDate ? "".concat(startDate.date()).concat(startDate.month()).concat(startDate.year()) : 'inout',
        type: "text",
        className: "roo-input roo-input-inline roo-input-xs",
        onChange: function onChange() {},
        value: startDate.format(dateFormat)
      }), /*#__PURE__*/React.createElement(Trigger, {
        builtinPlacements: getPlacements(flip || false),
        popupPlacement: placement,
        action: ['click'],
        popupStyle: {
          whiteSpace: 'nowrap'
        },
        getPopupContainer: isFunction(popupContainer) ? popupContainer : function () {
          return popupContainer;
        },
        popup: /*#__PURE__*/React.createElement(TimeSelect, {
          className: timeClassName,
          disabledTime: disabledTime,
          key: selectDate.format('YYYYMMDD HH:mm:ss'),
          value: selectDate,
          defaultValue: selectDate,
          onChange: this.selectTime
        })
      }, /*#__PURE__*/React.createElement(Input, {
        key: "".concat(selectDate.format('YYYYMMDD HH:mm:ss')),
        className: "roo-input roo-input-inline roo-input-xs",
        value: selectDate.format('HH:mm:ss')
      }))) : null, /*#__PURE__*/React.createElement(YearPanel, {
        show: yearShow,
        startDate: startDate,
        selectDate: selectDate,
        onSelectYear: this.selectMonthOrYear,
        handleChangeDate: this.handleChangeDate,
        disabledDate: disabledDate
      }), /*#__PURE__*/React.createElement(MonthPanel, {
        show: monthShow,
        startDate: startDate,
        selectDate: selectDate,
        onShowPanel: this.showPanel,
        onSelectMonth: this.selectMonthOrYear,
        handleChangeDate: this.handleChangeDate,
        disabledDate: disabledDate
      }), /*#__PURE__*/React.createElement(DatePanel, {
        show: dateShow,
        startDate: startDate,
        selectDate: type !== 'week' ? [selectDate] : [selectDate, selectEndDate],
        onShowPanel: this.showPanel,
        onSelectDate: this.selectDate,
        handleChangeDate: this.handleChangeDate,
        disabledDate: disabledDate,
        type: type,
        dateCellRender: dateCellRender
      }));
      var monthPicker = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MonthPanel, {
        key: selectDate ? selectDate.format('YYYYMM') : Math.random(),
        show: true,
        startDate: startDate,
        selectDate: selectDate,
        onShowPanel: this.showPanel,
        onSelectMonth: this.selectMonthOrYear,
        handleChangeDate: this.handleChangeDate,
        disabledDate: disabledDate,
        dateType: type
      }));
      var yearPicker = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(YearPanel, {
        key: selectDate ? selectDate.format('YYYYMMDD') : Math.random(),
        show: true,
        startDate: startDate,
        selectDate: selectDate,
        onSelectYear: this.selectMonthOrYear,
        handleChangeDate: this.handleChangeDate,
        disabledDate: disabledDate,
        dateType: type
      }));

      switch (type) {
        case 'month':
          bodyPanel = monthPicker;
          break;

        case 'year':
          bodyPanel = yearPicker;
          break;

        default:
          bodyPanel = datePicker;
          break;
      }

      var inputValue = '';

      if (type === 'week') {
        inputValue = value ? "".concat(value && value.year(), "-").concat(this.getThWeek(value), " ").concat(locale.lng('DatePicker.week')) : '';
      } else {
        inputValue = value ? value.format(format) : '';
      }

      return /*#__PURE__*/React.createElement(Trigger, {
        builtinPlacements: getPlacements(flip),
        popupPlacement: placement,
        onPopupVisibleChange: this.popupVisibleChange,
        popupVisible: disabled ? false : open,
        getPopupContainer: isFunction(popupContainer) ? popupContainer : function () {
          return popupContainer;
        },
        action: ['click'],
        popup: /*#__PURE__*/React.createElement("div", {
          className: "roo-datepicker ".concat(className),
          ref: this.rootNode
        }, bodyPanel)
      }, /*#__PURE__*/React.createElement(Input, {
        placeholder: placeholder,
        inputRef: this.inputNode,
        onFocus: this.inputFocus,
        onBlur: this.inputBlur,
        disabled: disabled,
        size: size,
        readOnly: true,
        className: inputClassName,
        suffix: clearable && !disabled ? /*#__PURE__*/React.createElement(IconClear, {
          onClick: this.clearTime
        }) : /*#__PURE__*/React.createElement(Icon, {
          name: "calendar"
        }),
        value: inputValue
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      var type = nextProps.type,
          valueOfType = nextProps.valueOfType,
          value = nextProps.value;
      var selectDate = state.selectDate,
          stateValue = state.value; // 如何杜绝，年月更新导致的状态更新

      if (!value && 'value' in nextProps) {
        if (stateValue) {
          return {
            value: '',
            startDate: dayjs(),
            selectDate: dayjs('0')
          };
        } else {
          return {
            value: ''
          };
        }
      }

      var nowValue = dateFormatter(value, valueOfType) || dayjs();

      if (type === 'week') {
        if ('value' in nextProps && nowValue.valueOf() !== state.value.valueOf()) {
          var realDate = nowValue;

          while (realDate.day() !== 1) {
            realDate = realDate.subtract(1, 'day');
          }

          return {
            value: nowValue,
            selectDate: realDate,
            startDate: realDate,
            selectEndDate: realDate.add(6, 'day').set('hour', 0).set('minute', 0).set('second', 0)
          };
        } else {
          return {};
        }
      } // 值对比是为了防止年月更改带来的 value 变动


      if ('value' in nextProps && nowValue.valueOf() !== state.value.valueOf()) {
        return {
          value: dateFormatter(value, valueOfType),
          startDate: dateFormatter(value, valueOfType) || dayjs(),
          selectDate: dateFormatter(value, valueOfType) || dayjs(),
          initialValue: nextProps.value
        };
      }

      return null;
    }
  }]);

  return DatePicker;
}(React.Component);

DatePicker.defaultProps = {
  defaultValue: '',
  className: '',
  inputClassName: '',
  timeClassName: '',
  // value: '',
  type: 'date',
  showTime: false,
  clearable: false,
  placeholder: locale.lng('DatePicker.placeholder'),
  size: 'normal',
  disabled: false,
  placement: 'bottomLeft',
  flip: false,
  format: 'YYYY-MM-DD',
  valueOfType: 'timestamp',
  popupContainer: document.body || document.documentElement,
  open: false,
  disabledDate: function disabledDate() {
    return false;
  },
  disabledTime: function disabledTime() {
    return false;
  },
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onChange: function onChange() {}
};
DatePicker.propTypes = {
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  timeClassName: PropTypes.string,
  // eslint-disable-next-line
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number]),
  type: PropTypes.oneOf(['year', 'month', 'date', 'week']),
  showTime: PropTypes.bool,
  clearable: PropTypes.bool,
  placeholder: PropTypes.string,
  size: PropTypes.string,
  valueOfType: PropTypes.string,
  flip: PropTypes.oneOfType([PropTypes.bool]),
  placement: PropTypes.oneOf(['left', 'right', 'top', 'bottom', 'bottomLeft', 'bottomRight', 'topLeft', 'topRight']),
  format: PropTypes.string,
  disabled: PropTypes.bool,
  popupContainer: PropTypes.oneOfType([PropTypes.instanceOf(Element), PropTypes.func]),
  open: PropTypes.bool,
  disabledDate: PropTypes.func,
  disabledTime: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func
};
polyfill(DatePicker);
export default DatePicker;